import React from 'react';

export default function AgeAndGenderCard({ ageGenderData }) {
  if (!ageGenderData || ageGenderData.length === 0) {
    return null;
  }
  return (
    <div className="demographics-card">
      <div className="age-graph-header">
        <h2>Age and Gender</h2>
        <div className="right-section">
          <div>
            <span className="gender-color-span" style={{ backgroundColor: '#9d89f0' }} />
            <p>Female</p>
            <span>{ageGenderData?.reduce((a, b) => a + b.female * 100, 0).toFixed(2)}%</span>
          </div>
          <div>
            <span className="gender-color-span" style={{ backgroundColor: '#3a2c75' }} />
            <p>Male</p>
            <span>{ageGenderData?.reduce((a, b) => a + b.male * 100, 0).toFixed(2)}%</span>
          </div>
        </div>
      </div>
      <div className="age-gender-graph-container">
        {ageGenderData &&
          ageGenderData
            .slice(0, ageGenderData.length - 1)
            .map((data) => (
              <GraphSection
                key={data.code}
                femalePercent={(data.female * 100).toFixed(2)}
                malePercent={(data.male * 100).toFixed(2)}
                label={data.code}
              />
            ))}
      </div>
    </div>
  );
}

const GraphSection = ({ femalePercent, malePercent, label }) => {
  return (
    <div className="age-graph-section">
      <div className="graph-container">
        <div className="female-graph" style={{ height: `${femalePercent * 1.5}%` }}>
          <span className="percent-count">{femalePercent}%</span>
        </div>
        <div className="male-graph" style={{ height: `${malePercent * 1.5}%` }}>
          <span className="percent-count">{malePercent}%</span>
        </div>
      </div>
      <span className="graph-label">{label}</span>
    </div>
  );
};
